module.exports = __webpack_public_path__ + "img/cross-icon.1e928943.svg";